export default __webpack_public_path__ + "static/media/yo_9.3aba2035.mp3";